import api from '@/api'
import logger from '@/logger'
import logos from '@/logos'
import objects from '@/objects'
import store from '@/store'
import D2C_Entity from './Entity'

class D2C_Provider extends D2C_Entity {
  target = 'provider'
  static active = false
  static objectType = 'entityType'
  static typeName = 'provider'
  static fields = {
    ...D2C_Entity.fields,
    name: {
      autoselect: true,
      default: '',
      label: 'Name',
      path: 'name',
      required: true,
      width: 8,
      validate(value, entity) {
        if (!entity.created && store.getters.providersByName[value]) {
          return 'This name is already used'
        }
        return (value && value.length < 21) ? null : 'Must contains 1-20 symbols'
      },
      creating: {},
    },
    type: {
      label: 'Provider type',
      path: 'type',
      required: true,
      width: 8,
      validate() {
        return null
      },
      creating: {},
    },
    purpose: {
      enum: [
        {value: 'hosting', text: 'Hosting'},
        {value: 'storage', text: 'Storage'},
      ],
      label: 'Purpose',
      path: 'purpose',
      required: true,
      width: 6,
      validate() {
        return null
      },
      creating: {},
    },
  }
  static get _logo() {
    return logos.providers[this.providerType]
  }
  static get _providers() {
    return store.getters.providers.filter(provider => provider instanceof this)
  }
  static create(props) {
    const Constructor = objects._providersByType[props.type]
    if (Constructor) {
      return new Constructor(props)
    }
    logger.warning(`🚨 Unknown provider type: ${props.type}`)
    return new D2C_Provider(props)
  }
  constructor(props = {}) {
    if (!props.name) {
      props.name = `My ${props.type}`
    }
    super(props)
  }
  get _logo() {
    return this.constructor._logo
  }
  create() {
    return api.createProvider(this.type, this.getValues('creating'))
  }
  update(changes) {
    return api.updateProvider(this.type, this.id, changes || this.getChanges())
  }
  destroy() {
    return api.destroyProvider(this.id)
  }
  oauth() {
    if (this.constructor.oauth) {
      api.oauth(this.constructor.providerType.toLowerCase(), this.id)
    } else {
      logger.warning(`🚨 OAuth is not available for ${this.constructor.providerType} provider`)
    }
  }
}

export default D2C_Provider
